export default __webpack_public_path__ + "static/media/gift-registry.d4a6806f.svg";